module.exports = __webpack_public_path__ + "img/hzau_logo_h100.94f45da7.png";